// Full-page states outside the application shell.
import { Button, Heading, Text } from "@manapp/ui"
import type { ReactNode } from "react"

export function CenteredScreen({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <main className="bg-ui-bg-subtle flex min-h-screen items-center justify-center p-6">
      <div className="bg-ui-bg-base shadow-elevation-card-rest flex w-full max-w-sm flex-col gap-y-4 rounded-lg p-6">
        <Heading level="h1">{title}</Heading>
        {children}
      </div>
    </main>
  )
}

export function Message({ children }: { children: ReactNode }) {
  return (
    <Text size="small" className="text-ui-fg-subtle">
      {children}
    </Text>
  )
}

export function PrimaryAction({ onClick, children }: { onClick: () => void; children: ReactNode }) {
  return <Button onClick={onClick}>{children}</Button>
}
